import React from "react";
import { Col, Row, Input, Label, FormFeedback } from "reactstrap";

interface UserFormProps {
  validation: {
    values: any;
    errors: any;
    touched: any;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
    setFieldValue: (field: string, value: any) => void;
  };
  userData: any; // object from your backend
}

const UserForm: React.FC<UserFormProps> = ({ validation, userData }) => {

  const astrick = <span style={{ color: "red" }}>*</span>
  return (
    <div className="px-3 py-2">
      {/* <h5 className="mb-3">User Details</h5> */}

      <Row className="g-3">
        <Col md={4}>
          <Label>Email {astrick}</Label>
          <Input
            name="email"
            value={validation.values.email || ""}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={!!(validation.touched.email && validation.errors.email)}
          />
          <FormFeedback>{validation.errors.email}</FormFeedback>
        </Col>

      </Row>

      <Row className="g-3 mt-2">
        <Col md={4}>
          <Label>Gender {astrick}</Label>
          <Input
            name="gender"
            type="select"
            value={validation.values.gender.trim() || ""}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={!!(validation.touched.gender && validation.errors.gender)}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </Input>
            <FormFeedback>{validation.errors.gender }</FormFeedback>
        </Col>
        <Col md={4}>
          <Label>Date of Birth {astrick}</Label>
          <Input
            name="dob"
            type="date"
            value={validation.values.dob || ""}
            invalid={!!(validation.touched.dob && validation.errors.dob)}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
          <FormFeedback>{validation.errors.dob}</FormFeedback>

        </Col>
        <Col md={4}>
          <Label>CPR ID</Label>
          <Input
            name="cpr_id"
            value={validation.values.cpr_id || ""}
            invalid={!!(validation.touched.cpr_id && validation.errors.cpr_id)}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
          <FormFeedback>{validation.errors.cpr_id}</FormFeedback>

        </Col>
      </Row>

      <Row className="g-3 mt-2">
        <Col md={6}>
          <Label>Permanent Address {astrick} </Label>
          <Input
            type="textarea"
            name="per_address"
            value={validation.values.per_address || ""}
            onChange={validation.handleChange}
            invalid={!!(validation.touched.per_address && validation.errors.per_address)}
            onBlur={validation.handleBlur}
          />

          <FormFeedback>{validation.errors.per_address}</FormFeedback>

        </Col>
        <Col md={6}>
          <Label>Current Address {astrick}</Label>
          <Input
            type="textarea"
            name="curr_address"
            invalid={!!(validation.touched.curr_address && validation.errors.curr_address)}
            value={validation.values.curr_address || ""}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}

          />
          <FormFeedback>{validation.errors.per_address}</FormFeedback>

        </Col>
      </Row>

      <Row className="g-3 mt-2">
        <Col md={4}>
          <Label>Marital Status {astrick}</Label>
          <Input
            name="marital_status"
            type="select"
            value={validation.values.marital_status.trim() || ""}
            invalid={!!(validation.touched.marital_status && validation.errors.marital_status)}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          >
            <option value="">Select</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
          </Input>
          <FormFeedback>{validation.errors.marital_status}</FormFeedback>

        </Col>
        <Col md={4}>
          <Label>Occupation {astrick}</Label>
          <Input
            name="occupation"
            value={validation.values.occupation || ""}
            invalid={!!(validation.touched.occupation && validation.errors.occupation)}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}

          />
          <FormFeedback>{validation.errors.occupation}</FormFeedback>

        </Col>

      </Row>

    </div>
  );
};

export default UserForm;
